import { escapeCsvCell } from "./csvFileHelpers";
import { formatStockPercentCell } from "./stockPercentFormat";
import { formatStockCurrency } from "./stockHoldingsTable";
import {
  STOCK_BUY_REC_PCT_COLUMNS,
  STOCK_BUY_REC_TABLE_DEFAULT_VISIBLE,
} from "./stockBuyRecommendationColumns";

/**
 * @param {string[]} [columnIds]
 */
export function buildStockBuyRecCsvHeaderLine(columnIds) {
  const cols =
    Array.isArray(columnIds) && columnIds.length > 0 ? columnIds : STOCK_BUY_REC_TABLE_DEFAULT_VISIBLE;
  return cols.join(",");
}

/**
 * @param {Record<string, string>[]} rows UI rows (Yahoo column labels as keys)
 * @param {string[]} [columnIds]
 */
export function buildStockBuyRecCsvExportText(rows, columnIds) {
  const cols =
    Array.isArray(columnIds) && columnIds.length > 0 ? columnIds : STOCK_BUY_REC_TABLE_DEFAULT_VISIBLE;
  const lines = [buildStockBuyRecCsvHeaderLine(cols)];
  (rows || []).forEach((row) => {
    const cells = cols.map((col) => {
      const raw = row[col];
      if (STOCK_BUY_REC_PCT_COLUMNS.has(col)) {
        const { text, tone } = formatStockPercentCell(raw);
        return escapeCsvCell(tone === "empty" ? "" : text);
      }
      if (col === "Equity") {
        const equityRaw = row.equity != null ? row.equity : row.Equity;
        return escapeCsvCell(formatStockCurrency(equityRaw));
      }
      return escapeCsvCell(raw != null ? String(raw) : "");
    });
    lines.push(cells.join(","));
  });
  return lines.join("\n");
}
